import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDStack, FDHeadlineText } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import {
  ProcessSteps,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/Sections/ProcessStepSection/ProcessSteps';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['processSteps'], {
    _component: () => ProcessSteps,
  }, overrideReadOnly);


export const ProcessStepSectionLayout = ({
  resource,
}) => {
  return (
    <FDStack direction={'column'} spacing={4}>
      <FDStack direction={'column'} spacing={2} {...dataAttrs('tax-strategy-detail-process-step-section')}>
        <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'title'} />
        <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'processSteps'} />
      </FDStack>
    </FDStack>
  );
};

ProcessStepSectionLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
